import { m as d } from "./chunk-modal-context-tNw15YTy.js";
import { c as l } from "./chunk-consume-s_2mmxxA.js";
import { n } from "./chunk-property---aaewZr.js";
var m = Object.defineProperty, s = (r, t, o, h) => {
  for (var e = void 0, a = r.length - 1, i; a >= 0; a--)
    (i = r[a]) && (e = i(t, o, e) || e);
  return e && m(t, o, e), e;
};
const p = (r) => {
  class t extends r {
    get currentTargetId() {
      return this.tagName === "DIALOG-TOGGLE" || this.tagName === "QUICK-SHOP" ? this.modalId : this.id;
    }
    get modalIsOpen() {
      return !!(this.currentTargetId && this.modals.includes(this.currentTargetId));
    }
    openModal() {
      !this.currentTargetId || this.modalIsOpen || this.$emit("modal-dialog::open", this.currentTargetId);
    }
    closeModal() {
      !this.currentTargetId || !this.modalIsOpen || this.$emit("modal-dialog::close", this.currentTargetId);
    }
    closeAllModals() {
      this.$emit("modal-dialog::close-all");
    }
  }
  return s([
    l({ context: d, subscribe: !0 })
  ], t.prototype, "modals"), s([
    n({ type: String, attribute: "modal-id" })
  ], t.prototype, "modalId"), t;
};
export {
  p as W
};
